/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import "./renderHomePageHeader.css";
import { AuthConsumer } from "../../AuthContext";
import { Link } from "react-router-dom";

export function renderHomePageHeader(func) {
  function renderHeader(t, i18n) {
    const headerLink = "/" + i18n.language;
    const languageObj = t("HOMELOGIN", { returnObjects: true });

    function handleChange(e) {
      const change = e.target.value;
      i18n.changeLanguage(change);
      let link = "/" + change;
      const pageName = func.constructor.name;
      let targetPage = pageName;
      if (pageName.length > 2) {
        link += targetPage.substring(2);
      }
      func.props.history.push(link);
    }

    return (
      <div className="renderHomePageHeader-outsideHeader">
        <div className="renderHomePageHeader-headerContainer">
          <div className="renderHomePageHeader-bg" />
        </div>

        <div className="renderHomePageHeader-navBar">
          <div
            className="renderHomePageHeader-menuBtn"
            onClick={() => func.showModal()}
          >
            <div className="renderHomePageHeader-menuIcn" />
          </div>

          <Link to={headerLink}>
            <div className="renderHomePageHeader-CheckPlusLogo" />
          </Link>

          <div className="renderHomePageHeader-rightContainer">
            <Link to="/OrgLogin">
              <div className="renderHomePageHeader-logoutContainer">
                <div className="renderHomePageHeader-logoutTxt">
                  {languageObj.btn}
                </div>
              </div>
            </Link>

            <Link to="/OrgSignup">
              <div className="renderHomePageHeader-signup-container">
                <div className="renderHomePageHeader-signup-txt">
                  {languageObj.signup}
                </div>
              </div>
            </Link>

            <div className="renderHomePageHeader-languageSelector">
              <div className="renderHomePageHeader-globe" />
              <select
                onChange={handleChange}
                value={i18n.language}
                className="renderLanguageSelector-select"
              >
                <option value="zh">繁體中文</option>
                <option value="cn">简体中文</option>
                <option value="en">English</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <AuthConsumer>{({ t, i18n }) => renderHeader(t, i18n)}</AuthConsumer>;
}
